import { DialogBody, Popover, StyledDialog, spaceMixin, token } from '@zillow/constellation';
import styled, { css } from 'styled-components';

type StyledDivProps = {
  isScrollable?: boolean;
  showScrollGradient?: boolean;
};

export const StyledDivVisibilitySensor = styled.div`
  height: 1px;
`;

export const StyledDiv = styled.div<StyledDivProps>`
  margin: 0 ${spaceMixin('xs')};
  width: 50px;

  ${(props: StyledDivProps) =>
    props.isScrollable &&
    css`
      height: 262px;
      overflow: scroll;

      ::-webkit-scrollbar {
        width: 0px;
        background: transparent; /* make scrollbar transparent */
      }
    `};

  ${(props: StyledDivProps) =>
    props.showScrollGradient &&
    css`
      &::after {
        content: '';
        display: block;
        position: absolute;
        bottom: 16px;
        width: 59px;
        height: 84px;
        background-image: linear-gradient(to bottom, rgba(255, 255, 255, 0), #fff);
        pointer-events: none;
      }
    `};
`;

export const StyledTimeValueContainer = styled.div`
  text-align: center;
  padding: 8px 0;
  margin: 4px 0;
  cursor: pointer;

  &.TimePicker-highlighted-value {
    border-radius: 3px;
    background-color: ${token('colors.blue200')};
  }
`;

export const StyledPopover = styled(Popover)`
  > ${StyledDialog} {
    width: 175px;

    > ${DialogBody} {
      overflow-y: initial;
    }
  }
`;
